// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2848":"css/web","4603":"css/auth","6170":"css/app"}[chunkId] + ".css";
};